import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { ref, onMounted, computed } from 'vue';
import { ConfigProvider, message } from 'ant-design-vue';
import { antdPrefixCls } from '@/constant';
import CashierCounter from '@/components/CashierCounter/index.vue';

import { getSearchParams } from '@/utils/location';
import { IOrderParams } from '@/components/CashierCounter/utils/config';
import { ISUBMIT_SOURCE } from '@/apis/common';


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

ConfigProvider.config({
  prefixCls: antdPrefixCls,
});

message.config({
  top: `90px`,
});
const orderData = ref<IOrderParams>();

const hasHeader = computed(() => {
  // 如果 URL 参数中有 hasHeader，使用该值；否则默认为 true
  return orderData.value?.hasHeader !== undefined
    ? orderData.value.hasHeader === 'true' || orderData.value.hasHeader === true
    : true;
});

const platform = computed(() => {
  return orderData.value?.platform || ISUBMIT_SOURCE.PC;
});

const orderNo = computed(() => {
  return orderData.value?.orderNo;
});

const contractNo = computed(() => {
  return orderData.value?.contractNo;
});

const appKey = computed(() => {
  return orderData.value?.appKey || '';
});

const failRedirect = computed(() => {
  return orderData.value?.failRedirect || '';
});

const succRedirect = computed(() => {
  return orderData.value?.succRedirect || '';
});

onMounted(() => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const query = getSearchParams() as any as IOrderParams;
  orderData.value = query;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(ConfigProvider), { prefixCls: _unref(antdPrefixCls) }, {
    default: _withCtx(() => [
      (orderNo.value || contractNo.value)
        ? (_openBlock(), _createBlock(CashierCounter, {
            key: 0,
            hasHeader: hasHeader.value,
            platform: platform.value,
            orderNo: orderNo.value,
            contractNo: contractNo.value,
            appKey: appKey.value,
            failRedirect: failRedirect.value,
            succRedirect: succRedirect.value
          }, null, 8, ["hasHeader", "platform", "orderNo", "contractNo", "appKey", "failRedirect", "succRedirect"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["prefixCls"]))
}
}

})